import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { addSpaceEvery4, GetStatus, removeNonNumeric } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import XIcon from "assets/icon/XIcon";
import FilterIcon from "assets/icon/FilterIcon";
import { useCallApi } from "api/apiHooks";
import { useModal } from "context/ModalContext";
import Pagination from "components/Input/PaginationButton";
import { FilterCard, PagesTitle } from "components/Cards";

export default function CustomerCard(){
    let navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerCardList, fetchBankList, fetchCardVendorList, fetchDeleteCustomerCard } = useCallApi()

    const [customerCardList, setCustomerCardList] = useState([])
    const [customerName, setCustomerName] = useState(EmptyString)
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [bankId, setBankId] = useState(EmptyString)
    const [cardVendorId, setCardVendorId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [cardVendorOptions, setCardVendorOptions] = useState([])
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    
    const isFilterOpenClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchCustomerCardList(
                customerName, 
                cardNumber, 
                bankId === EmptyString ? 0 : parseInt(bankId), 
                cardVendorId === EmptyString ? 0 : parseInt(cardVendorId), 
                status, 
                PageSize, 
                parseInt(newIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setCustomerCardList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}

    const searchBtnClick = () => {
        handlePageChange(0)
    }
    const addBtnClick = () => {
        navigate("/customer-card/form?customerCardId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (customerCardId) => {
        navigate("/customer-card/form?customerCardId=" + customerCardId + "&formType=Edit")
    }
    const deleteBtnClick = async (customerCardId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteCustomerCard(customerCardId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }


    useEffect(() => {
        const firstLoad = async () => {
            showLoading()

            // Get Bank List
            const res = await fetchBankList('', '', '1', 10000, 0)

            if (!res) return

            let data = res.data.listData
            let tempArray = []

            tempArray.push({ label: "All", value: "" })

            for (let i = 0; i < data.length; i++){
                tempArray.push({ label: data[i].bankCode + " - " + data[i].bankName, value: String(data[i].bankId) })
            }

            setBankOptions(tempArray)
            setBankId(tempArray[0].value)

            // Get Vendor List
            const res2 = await fetchCardVendorList('', '1', 1000, 0)

            if (!res2) return

            let data2 = res2.data.listData
            let tempArray2 = []

            tempArray2.push({ label: "All", value: "" })

            for (let i = 0; i < data2.length; i++){
                tempArray2.push({ label: data2[i].cardVendorName, value: String(data2[i].cardVendorId) })
            }

            setCardVendorOptions(tempArray2)
            setCardVendorId(tempArray2[0].value)

            handlePageChange(0)
        }

        firstLoad()
    },[])

    return(
        <div className="flex flex-col gap-2">
            <PagesTitle title='Kartu Pelanggan' />

            <div className="xl:hidden mt-2 flex justify-end">
                <button className="bg-black rounded-md flex gap-2 px-4 py-2" onClick={isFilterOpenClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6" /> : <FilterIcon className="fill-white w-6" />}
                    <span className="text-white">Filter</span>
                </button>
            </div>

            <div className={`flex flex-col xl:flex-row gap-5 justify-between mt-2 ${isFilterOpen ? 'flex' : 'hidden xl:flex'}`}>
                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 w-full">
                    <FilterCard title='Nama Pelanggan'>
                        <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title='Nomor Kartu'>
                        <input className="input" value={cardNumber} onChange={(e) => { setCardNumber(removeNonNumeric(e.target.value)) }} onKeyDown={filterEnterKeyPress} />
                    </FilterCard>
                    <FilterCard title='Bank'>
                        <Dropdown value={bankId} options={bankOptions} onChange={(e) => { setBankId(e.value) }} placeholder={"All"} />
                    </FilterCard>
                    <FilterCard title='Vendor'>
                        <Dropdown value={cardVendorId} options={cardVendorOptions} onChange={(e) => { setCardVendorId(e.value) }} placeholder={"All"} />
                    </FilterCard>
                    <FilterCard title='Status' width='w-full sm:w-32'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </FilterCard>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="hidden xl:block mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Customer Name</th>
                            <th className="font-semibold text-left px-2">Card Number</th>
                            <th className="font-semibold text-left px-2">Bank</th>
                            <th className="font-semibold text-left px-2">Card Vendor</th>
                            <th className="font-semibold text-left px-2">MDR</th>
                            <th className="font-semibold text-left px-2">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {customerCardList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.customerName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ addSpaceEvery4(data.cardNumber) }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.bankName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.cardVendorName }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.mdr }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick(data.customerCardId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <div className="block xl:hidden mt-5">
                <div className="flex flex-col gap-3">
                    {customerCardList?.data?.listData?.map((data, i) => {
                        return(
                            <div className="bg-white p-3 border shadow flex justify-between">
                                <div className="flex flex-col">
                                    <label>{data.customerName.toUpperCase()}</label>
                                    <label>{data.cardNumber}</label>
                                    <label>{data.bankName + " - " + data.cardVendorName}</label>
                                </div>
                                <div className="flex flex-col justify-between">
                                    <button className="button flex gap-2" onClick={() => editBtnClick(data.customerCardId)}>
                                        <EditIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <TrashIcon className="w-4 fill-white" />
                                    </button>
                                    <button className={`button flex gap-2 ${ data.status === StatusCodeActive ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.customerCardId, data.status)}>
                                        <RevisionIcon className="w-4 fill-white" />
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    )
}